module.exports = __webpack_public_path__ + "media/images/testimonial2-28717091281f6b941176182edb91b405.jpg";